import {
  ADD_ROLE_FAIL,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  EDIT_ROLE_FAIL,
  EDIT_ROLE_REQUEST,
  EDIT_ROLE_SUCCESS,
  GET_MODULE_FAIL,
  GET_MODULE_REQUEST,
  GET_MODULE_SUCCESS,
  GET_ROLE_FAIL,
  GET_ROLE_LIST_DATA_FAIL,
  GET_ROLE_LIST_DATA_REQUEST,
  GET_ROLE_LIST_DATA_SUCCESS,
  GET_ROLE_REQUEST,
  GET_ROLE_SUCCESS,
} from "../constant";

const initialState = {
  roleData: [],
  totalRecords: null,
  addRoleFormData: {},
  moduleData: null,
  roleDataLoading: false,
  isAddingRole: false,
  isDeletingRole: false,
  deleteMessage: null,
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    //Get survey
    case GET_ROLE_REQUEST:
      return {
        ...state,
        roleData: [],
        totalRecords: null,
        roleDataLoading: true,
      };
    case GET_ROLE_SUCCESS:
      return {
        ...state,
        roleData: action.payload?.data,
        totalRecords: action.payload?.totalRecords,
        roleDataLoading: false,
      };
    case GET_ROLE_FAIL:
      return {
        ...state,
        roleData: [],
        totalRecords: null,
        roleDataLoading: false,
      };

    //Get survey list data
    case GET_ROLE_LIST_DATA_REQUEST:
      return {
        ...state,
      };
    case GET_ROLE_LIST_DATA_SUCCESS:
      const listData = action.payload;
      let tmpList = state?.roleData?.map((role) => ({
        ...role,
        ...listData[role.role_id],
      }));
      return {
        ...state,
        roleData: [...tmpList],
      };
    case GET_ROLE_LIST_DATA_FAIL:
      return {
        ...state,
      };

    case GET_MODULE_REQUEST:
      return {
        ...state,
        moduleData: null,
      };
    case GET_MODULE_SUCCESS:
      return {
        ...state,
        moduleData: action.payload,
      };
    case GET_MODULE_FAIL:
      return {
        ...state,
        moduleData: null,
      };

    //Add user
    case ADD_ROLE_REQUEST:
      return {
        ...state,
        isAddingRole: true,
      };
    case ADD_ROLE_SUCCESS:
      return {
        ...state,
        isAddingRole: false,
      };
    case ADD_ROLE_FAIL:
      return {
        ...state,
        isAddingRole: false,
      };
    case EDIT_ROLE_REQUEST:
      return {
        ...state,
        isAddingRole: true,
      };
    case EDIT_ROLE_SUCCESS:
      return {
        ...state,
        isAddingRole: false,
      };
    case EDIT_ROLE_FAIL:
      return {
        ...state,
        isAddingRole: false,
      };
    case DELETE_ROLE_REQUEST:
      return {
        ...state,
        isDeletingRole: true,
      };
    case DELETE_ROLE_SUCCESS:
      //console.log("payload", action.payload);
      if (action.payload) {
        return {
          ...state,
          deleteMessage: action.payload,
          isDeletingRole: false,
        };
      } else {
        return {
          ...state,
          isDeletingRole: false,
        };
      }
    case DELETE_ROLE_FAIL:
      return {
        ...state,
        isDeletingRole: false,
      };

    default:
      return state;
  }
};

export { roleReducer };
